import { useEffect, useState } from "react";
import { Mail, Save, Send } from "lucide-react";
import { toast } from "sonner";
import { http, errMsg } from "@/lib/api";

export const NotifySettings = () => {
  const [value, setValue] = useState("");
  const [saved, setSaved] = useState([]);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    http.get("/admin/notify-emails").then((r) => {
      const list = Array.isArray(r.data?.emails) ? r.data.emails : [];
      setSaved(list);
      setValue(list.join(", "));
    }).catch(() => {});
  }, []);

  const save = async () => {
    const emails = value.split(/[,\s]+/).map((e) => e.trim()).filter(Boolean);
    setBusy(true);
    try {
      const r = await http.put("/admin/notify-emails", { emails });
      setSaved(r.data?.emails ?? []);
      toast.success("Notification emails saved");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  const test = async () => {
    setBusy(true);
    try {
      const r = await http.post("/admin/test-email");
      const res = Array.isArray(r.data?.results) ? r.data.results : [];
      res.forEach((x) => (x.ok ? toast.success(`Test sent to ${x.to}`) : toast.error(`${x.to || "Not sent"}: ${x.info}`)));
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <section className="mt-8 border border-[var(--line)] bg-[var(--char)] p-6" data-testid="notify-settings">
      <p className="flex items-center gap-2 font-mono-x text-[12px] uppercase tracking-[0.14em] text-zinc-300"><Mail className="w-4 h-4 text-[var(--orange)]" />Send new quotes to</p>
      <div className="mt-3 flex flex-col sm:flex-row gap-2">
        <input className="field" value={value} onChange={(e) => setValue(e.target.value)} placeholder="you@email.com, partner@email.com" data-testid="notify-emails-input" />
        <button onClick={save} disabled={busy} className="btn-orange justify-center px-5 py-3 shrink-0" data-testid="notify-emails-save-btn"><Save className="w-4 h-4" /><span>Save</span></button>
        <button onClick={test} disabled={busy} className="btn-ghost justify-center px-5 py-3 shrink-0" data-testid="admin-test-email-btn"><Send className="w-4 h-4" />Test email</button>
      </div>
      <p className="mt-2 text-xs text-zinc-400" data-testid="notify-emails-current">
        {saved.length ? `Currently emailing: ${saved.join(", ")}` : "No addresses set — quotes will not be emailed until you add one."}
      </p>
    </section>
  );
};
